import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as actionsLinePicking from '../../../actions/linePickingAction';
import LinePickingService from '../../../services/LinePickingService';
import { translate, formatData, gerarCSV, isNullOrEmpty, closeCollapsible } from '../../../utils/util';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';
import { Input, BackButton, Title, Button, Collapsible } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import InfiniteScrollUl from '../../../components/UI/InfiniteScrollUl';

const ListTransmissions = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            orderCode: undefined,
            orderItemCode: undefined,
            message: undefined,
            erro: false,
            operation: undefined,
            dateStart: undefined,
            dateEnd: undefined,
            ordertype: props.location?.state?.type
        });
    const [transmissions, setTransmissions] = useState([]);

    useEffect(() => {
        if (props.transmissions?.items?.length > 0) {
            if (transmissions.length > 0 && currentPage === 0) {
                setTransmissions([...props.transmissions.items]);
            } else {
                setTransmissions((prevState) => ([...prevState, ...props.transmissions.items]));
            }
        } else {
            setTransmissions([]);
        }
        // eslint-disable-next-line
    }, [props?.transmissions?.items]);

    useEffect(() => {
        getTransmissionFilter(false, false)
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getTransmissionFilter(false, false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const getReport = () => {
        if (validateInputsRequired("getReport")) {
            getTransmissionFilter(true, false);
        }
    }

    const getTransmissionFilter = (report, click) => {
        var currentPageList = click || report ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }

        props.getTransmissions(Object.assign(filter, {
            PageSize: report ? undefined : 25,
            PageIndex: currentPageList
        }), report, (data) => {
            if (report && data.items) {
                gerarCSV("ReportTransmission", data.items);
            }

            if (click) {
                closeCollapsible("collapsible2")
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };


    const onSelectChange = (item) => {
        props.setTransmission(item);
        props.history.push({
            pathname: `../../linePicking/transmissions/details`
        });
    }

    const validateRequired = () => {
        if (!isNullOrEmpty(filter.orderCode) || !isNullOrEmpty(filter.orderItemCode)) {
            return false;
        }
        return true;
    }

    const formatOrderCode = (item) => {
        if (isNullOrEmpty(item.orderCode) && item?.operation === "A07") {
            return translate('line-picking:linepicking.manual-call');
        }

        return item.orderCode;
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('line-picking:transmission.title')} />
            </div>
            {
                checkPermission(PERMISSIONS.LinePicking.SmallParts.Access) &&
                <div className="title" style={{ float: 'right', margin: '5px' }}>
                    <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => props.forceTramission()}>{'refresh'}</i>
                </div>
            }
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <form id="getReport">
                                    <div className="row">
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                defaultValue={filter.dateStart}
                                                type="date"
                                                label={translate('change-location:startDate')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                                required={validateRequired()}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                defaultValue={filter.dateEnd}
                                                type="date"
                                                label={translate('change-location:endDate')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                                required={validateRequired()}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="orderCode"
                                                name='orderCode'
                                                label={translate('line-picking:transmission.call')}
                                                type="text"
                                                defaultValue={filter?.orderCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="orderItemCode"
                                                name='orderItemCode'
                                                label={translate('line-picking:linepicking.task')}
                                                type="text"
                                                onChange={onChange}
                                                defaultValue={filter?.orderItemCode || ''}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="message"
                                                name='message'
                                                label={translate('line-picking:linepicking.return')}
                                                type="text"
                                                onChange={onChange}
                                                defaultValue={filter?.message || ''}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s4">
                                            <Input
                                                id="operation"
                                                name='operation'
                                                label="Operação"
                                                type="text"
                                                onChange={onChange}
                                                defaultValue={filter?.operation || ''}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s2">
                                            <Input
                                                id="erro"
                                                name="erro"
                                                type="checkbox"
                                                label={translate('line-picking:linepicking.fail')}
                                                onChange={onChange}
                                                defaultChecked={filter?.erro}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => getTransmissionFilter(false, true)} />
                                </div>
                            </>
                        }
                    />
                    {
                        transmissions.length > 0 &&
                        <div className="row" style={{ paddingTop: '1px' }}>
                            <Button full="true" text="Download" onClick={getReport} />
                        </div>
                    }
                </div>
                <InfiniteScrollUl
                    page={props.transmissions?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.transmissions?.totalPages}
                    data={transmissions.map((item) => (
                        <div
                            className="row"
                            style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                            onClick={() => {
                                onSelectChange(item);
                            }}
                        >
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {formatOrderCode(item) || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {item?.orderItemCode || ''}
                            </span>
                            <div className="title sixth-text-color">
                                {item?.operation || ''}
                            </div>
                            {
                                !isNullOrEmpty(item.attempt) && parseInt(item.attempt) > 1 && (
                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:transmission.erro-send')} - {item.originType === 1 ? "CLICK " : "GEMAP "} {formatData(item.createOn)}
                                    </div>
                                )}
                            {
                                item?.success && (
                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:transmission.send')} - {item.originType === 1 ? "CLICK " : "GEMAP "} {formatData(item?.updateOn || '')}
                                    </div>
                                )}
                            <div className="col s12 second-text-color"  >
                                {translate('line-picking:linepicking.attempts')}: {item.attempt || ''}
                            </div>
                        </div>
                    ))}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.linePickingReducer.transmissions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, report, callback) => {
            dispatch(LinePickingService.getTransmission(filter, report, callback));
        },
        setTransmission: (item) => {
            dispatch(actionsLinePicking.selectTransmission(item));
        },
        forceTramission: () => {
            dispatch(LinePickingService.forceTramission());
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListTransmissions)));
